import { useLocation } from "react-router-dom";
import { authenticationApi } from "../api/authentication.api";

/**
 * Redirects to the backend's Google OAuth endpoint for social sign-in.
 * Forwards this page's own location.state (redirectTo/pendingQuery/
 * openGuidedSearch/entryPoint) through the OAuth round trip -- see
 * authenticationApi.googleOAuthUrl's docstring for why that's necessary at
 * all (a real browser navigation away from the SPA, unlike the password/OTP
 * path, which reads this same state directly with no round trip to lose it).
 */
export default function SocialAuthButtons() {
    const location = useLocation();

    return (
        <>
            <div className="ogm-divider">OR</div>

            <button
                type="button"
                className="ogm-google-btn"
                onClick={() => {
                    window.location.href = authenticationApi.googleOAuthUrl(location.state);
                }}
            >
                <img src="/google.svg" alt="" aria-hidden="true" />
                Continue with Google
            </button>
        </>
    );
}
